import React from 'react';
import { Box, Typography, TextField, Paper } from '@mui/material';
import { Flag } from '@mui/icons-material';

const ValueInput = ({ 
  dataPoint, 
  index, 
  goalType, 
  measurementUnit, 
  handleFieldChange 
}) => {
  if (dataPoint?.value === 'N/A' || goalType === 'Trials'||goalType==='Prompting'||goalType==='Physical Assistance') {
    return null;
  }

  return (
    <Paper 
      elevation={1}
      sx={{ 
        p: 2, 
        mb: 2, 
        backgroundColor: 'transparent',
        border: '1px solid #e5e7eb',
        borderRadius: '8px'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Flag sx={{ color: '#6b7280', mr: 1, fontSize: 18 }} />
        <Typography 
          variant='body1' 
          sx={{ 
            color: '#1f2937',
            fontWeight: 400,
            fontSize: '1rem'
          }}
        >
          Main Target
        </Typography>
      </Box>
      
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <Typography 
          variant='body2' 
          sx={{ 
            color: '#1f2937',
            fontWeight: 400,
            minWidth: '45px'
          }}
        >
          Value:
        </Typography>
        <TextField
          type='text'
          inputProps={{
            'aria-label': 'Main target value',
            inputMode: 'numeric',
          }}
          margin='dense'
          size='small'
          value={dataPoint?.value}
          sx={{ 
            width: '100px',
            '& .MuiOutlinedInput-root': {
              backgroundColor: 'white',
              '&:hover': {
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#6b7280',
                }
              },
              '&.Mui-focused': {
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#6b7280',
                }
              }
            }
          }}
          onChange={(e) => {
            const newValue = e.target.value;
            if (newValue === '' || !isNaN(newValue)) {
              handleFieldChange(index, 'value', newValue);
            }
          }}
        />
        {measurementUnit && (
          <Typography 
            variant='body2' 
            sx={{ 
              color: '#1f2937',
              fontWeight: 400
            }}
          >
            {measurementUnit}
          </Typography>
        )}
      </Box>
    </Paper>
  );
};

export default ValueInput;